import React from 'react';
import PropTypes from 'prop-types';
import Typography from 'Components/UI/Typography';
import {
  FDCheckboxInput, FDStack,
} from '@facet-wealth/design';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { dataAttrs } from 'Helpers/Testing';

function MultipicklistNewSelectItem({
  onChange,
  isSelected,
  testName,
  itemId,
  itemPrompt,
}) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        border: '1px solid #eeeeee',
        borderRadius: '8px',
        padding: `${theme.spacing(2, 0, 2, 2)}`,
        backgroundColor: isSelected ? `${theme.palette.facet.accentBlue21}` : 'white',
        '&:hover': {
          cursor: 'pointer',
        },
      }}
      onClick={() => onChange(!isSelected)}
    >
      <FDStack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
        <Typography variant="h4" weight="medium" color={'black'}>
          {itemPrompt}
        </Typography>
        <FDCheckboxInput
          alignSelf={'flex-end'}
          checked={isSelected}
          label={''}
          onChange={(e) => onChange(e.target.checked)}
          {...dataAttrs(`multipicklist-${testName}-option-${itemId}`)}
        />
      </FDStack>
    </Box>
  );
}

MultipicklistNewSelectItem.defaultProps = {
};

MultipicklistNewSelectItem.propTypes = {
  onChange: PropTypes.func.isRequired,
  testName: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  itemId: PropTypes.string.isRequired,
  itemPrompt: PropTypes.string.isRequired,
};

export default MultipicklistNewSelectItem;
